export const API_PET_URL =
  "https://us-central1-pet-finder-450419.cloudfunctions.net/adddatatopet";

export const API_LIST_PET =
  "https://us-central1-pet-finder-450419.cloudfunctions.net/listPet";
